import { change, FieldArray } from 'redux-form';
import React, { useEffect, useRef, useState } from 'react';
import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import RenderStepsArray from './RenderStepsArray';
import RenderPhaseStepsArray from './RenderPhaseStepsArray';
import GeneralEnumService from 'src/enumerables/general-enum';
import classNames from 'classnames';
import styles from './assets/program-array-fields.module.scss';
import { useSelector } from 'react-redux';
import { StoreState } from '../../../../../../../../../../store/reducers';
import { useTimer } from '../timer/useTimer';
import {
    faPlay,
    faPause,
    faStop,
    faPencilAlt,
    faCheck,
    faMinusCircle,
    faChevronDown,
    faChevronUp,
    faEye,
    faEyeSlash,
    faBan,
    faChartBar,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import { FieldSelectList } from '../../../../../../../../../../components/redux-form/fields/FieldSelectList';
import { getValFromEnum } from '../../../../../../../../../../components/redux-form/utils/dropdown-values';
import user from '../../../../../../../../../../services/user-auth';
import UserRole from '../../../../../../../../../../enumerables/user-role';
import { useCookies } from 'react-cookie';
import { Link } from 'react-router-dom';
import Router from '../../../../../../../../../../navigation/router';
import { routes } from '../../../../../../../../../../navigation';

interface PBTargetFormProps {
    memberD: any;
    remove: any;
    showOption: boolean;
    showPrompt: boolean;
    fields: any;
    row: any;
    isMastered: boolean;
    isPhased: boolean;
    hideRow: any;
    showRow: any;
    setIsManualChangeValue: (it: boolean) => void;
    isManualChangeValue: any;
    setTargetManualChangeValue: (it: string) => void;
    targetManualChangeValue: any;
    programBookId?: any;
}

const PBTargetForm: React.FunctionComponent<PBTargetFormProps> = ({
    memberD,
    showOption,
    showPrompt,
    row,
    isMastered,
    isPhased,
    fields,
    hideRow,
    showRow,
    setIsManualChangeValue,
    isManualChangeValue,
    setTargetManualChangeValue,
    targetManualChangeValue,
    programBookId,
}: PBTargetFormProps) => {
    const GeneralEnum = GeneralEnumService ? GeneralEnumService.getEnum('ProgramType') : {};

    const seance = useSelector((state: StoreState) => state.seances.current);

    let [count, setCount] = useState(row.answer ? row.answer : 0);

    const [showAttempt, setShowAttempt] = useState(false);

    const dispatch = useDispatch();
    const countChangeTimeout = useRef<any>(null);

    const isProvider = user.getRoles().includes(UserRole.ROLE_USER);
    const isSupervisor = user.getSupervisor();
    const isJustProvider = isProvider && !isSupervisor;

    function incrementCount() {
        count = parseInt(count, 10) + 1;
        setCount(count);
        if (countChangeTimeout.current) clearTimeout(countChangeTimeout.current);
        countChangeTimeout.current = setTimeout(() => {
            dispatch(change('program-book', `${memberD}.answer`, count));
        }, 200);
        setIsManualChangeValue(true);
        setTargetManualChangeValue(row?.id);
    }
    function decrementCount() {
        count = parseInt(count, 10) - 1;
        setCount(count);
        if (countChangeTimeout.current) clearTimeout(countChangeTimeout.current);
        countChangeTimeout.current = setTimeout(() => {
            dispatch(change('program-book', `${memberD}.answer`, count));
        }, 200);
        setIsManualChangeValue(true);
        setTargetManualChangeValue(row?.id);
    }

    const { seconds, secondsManually, start, stop, pause, setSeconds, setSecondsManually, running } = useTimer({
        seconds: row.answer ? row.answer : 0,
        member: memberD,
    });

    const [frequencyValue, setFrequencyValue] = useState(row.answer ? row.answer : 0);

    useEffect(() => {
        setCount(row.answer ? row.answer : 0);
        setSeconds(row.answer ? row.answer : 0);
        setSecondsManually(
            row.answer ? zeroPad(Math.floor(row.answer / 60), 2) + ':' + zeroPad(row.answer % 60, 2) : 0,
        );
    }, [row.answer]);

    function zeroPad(num: number, places: number): string {
        const zero = places - num.toString().length + 1;
        return Array(+(zero > 0 && zero)).join('0') + num;
    }
    function manualChange() {
        if (typeof secondsManually === 'string') {
            const vars = secondsManually.split(':');
            setSeconds(parseInt(vars[0]) * 60 + parseInt(vars[1]));
            setTimeout(() => {
                dispatch(change('program-book', `${memberD}.answer`, parseInt(vars[0]) * 60 + parseInt(vars[1])));
            }, 200);
        }
        handleClose();
    }

    function manualChangeFrequency() {
        //if (typeof frequencyValue === 'string') {
        setFrequencyValue(parseInt(frequencyValue));
        setTimeout(() => {
            dispatch(change('program-book', `${memberD}.answer`, parseInt(frequencyValue)));
        }, 200);
        //}
        handleClose();
    }

    const [openModal, setOpened] = useState(false);
    const [percentOpened, setPercentOpened] = useState(false);
    const [percents, setPercents] = useState(row.answer && row.type == 1 ? row.answer : 0);
    const [curPer, setCurPer] = useState(-1);

    const [cookies, setCookie] = useCookies(['percent_target_' + row?.id + '_seance_' + seance?.id]);

    let recomendedMinAttemps = row?.minAttempts;
    if (row?.isPhased && row?.activePhase?.minAttempts) {
        recomendedMinAttemps = row?.activePhase?.minAttempts;
    }

    let defaultItems: any = [];
    if (cookies[`percent_target_${row?.id}_seance_${seance?.id}`]) {
        defaultItems = cookies[`percent_target_${row?.id}_seance_${seance?.id}`];
    } else {
        defaultItems = [];
        for (let i = 0; i < recomendedMinAttemps; i++) {
            defaultItems.push('');
        }
    }

    const [percentAttempts, setPercentAttempts] = useState(defaultItems);

    useEffect(() => {
        if (row.type == 1) {
            setPercents(row.answer ? row.answer : 0);
        }
    }, [row.answer, percentAttempts]);

    useEffect(() => {
        if (row.type == 1) {
            setPercents(percents ? percents : 0);
        }
    }, [percentAttempts, percents]);

    /* useEffect(() => {
        setPromptItemSelected(promptItemSelected);
        setPromptItemSelectedLabel(promptItemSelectedLabel);
    }, [row.promptItemSelected, promptItemSelected]);*/

    const handleClose = () => {
        setOpened(false);
    };
    const handlePercentClose = () => {
        setPercents(row.answer ? row.answer : 0);
        setPercentOpened(false);
    };

    function getPercentAttempt(i: number) {
        return percentAttempts[i];
    }

    function addAttempt() {
        percentAttempts.push('');
        setPercentAttempts(percentAttempts);
        setCurPer(1000 + Math.random());
    }
    function removeAttempt(i: number) {
        percentAttempts.splice(i, 1);
        setPercentAttempts(percentAttempts);
        setCurPer(2000 + Math.random());
    }

    let summary = 0;
    let counter = 0;
    function countPercentValue() {
        setPercentOpened(false);
        setShowAttempt(false);

        percentAttempts.map((member: any, index: number, array: any) => {
            member = member === '' ? 0 : member;
            summary = summary + member;
            counter = counter + 1;
        });

        setCookie('percent_target_' + row?.id + '_seance_' + seance?.id, percentAttempts, {
            path: '/',
        });

        setPercents(Math.round(summary / counter));
        dispatch(change('program-book', `${memberD}.answer`, Math.round(summary / counter)));
    }

    function reCountPercentValue() {
        percentAttempts.map((member: any, index: number, array: any) => {
            member = member === '' ? 0 : member;
            summary = summary + member;
            counter = counter + 1;
        });

        setCookie('percent_target_' + row?.id + '_seance_' + seance?.id, percentAttempts, {
            path: '/',
        });
        /*setPercents(Math.round(summary / counter));
        dispatch(change('program-book', `${memberD}.answer`, Math.round(summary / counter)));
        */
    }

    useEffect(() => {
        setPercentAttempts(percentAttempts);
    }, [curPer, percentAttempts]);

    let isMasteredLabel = '';
    /*if ((isMastered && !row?.isPhased) || (row?.isPhased && row?.activePhase?.isMastered)) {
        isMasteredLabel = ' (mastered)';
    }*/
    if (row?.isMastered) {
        isMasteredLabel = ' (mastered)';
    }

    const optionsPrompts: any = [];

    const EnumSet = GeneralEnumService ? GeneralEnumService.getEnum('ProgramPrompt') : {};
    const promptItems: SelectObject[] = getValFromEnum(EnumSet);
    let promptsTitles = '';

    if (row?.type == 3) {
        if (row?.programTargetOptions) {
            row?.programTargetOptions?.map((member: any, index: number, array: any) => {
                const valPrompt = promptItems.find((it) => it.value === member.prompt);
                optionsPrompts.push(valPrompt ? valPrompt.label : '');
            });
        }
        promptsTitles = optionsPrompts.join(', ');
    }

    if (row?.type == 1) {
        let promptVal = row?.prompt;
        if (row?.activePhase?.prompt) {
            promptVal = row?.activePhase?.prompt ?? promptVal;
        }
        const valPrompt = promptItems.find((it) => it.value === promptVal);
        promptsTitles = valPrompt ? valPrompt.label : '';
    }

    const [isHide, setHide] = useState(true);

    let isMasteredPhaseLabel = '';
    if (row?.activePhase?.isMastered) {
        isMasteredPhaseLabel = ' (mastered)';
    }
    const input = () => {
        switch (row.type) {
            //percentage
            case 1:
                return (
                    <div>
                        <div onClick={() => setHide(!isHide)}>
                            <FieldInput
                                name={`${memberD}.answer`}
                                disabled={isJustProvider && seance?.status === 4}
                                type={'hidden'}
                                input={{ value: percents, name: `${memberD}.answer` }}
                                wrapperConfig={{
                                    label: row?.title + ', %' + isMasteredLabel,
                                    classes: {
                                        inputWrapper: 'm-0',
                                        label: isMasteredLabel
                                            ? classNames(styles.answerTitle, styles.masteryMark)
                                            : classNames(styles.answerTitle),
                                    },
                                }}
                            />
                            <div className={classNames(styles.answerTitle, styles.targetPhase)}>
                                {row?.isPhased && row?.activePhase
                                    ? '  Phase: ' + row?.activePhase?.title + isMasteredPhaseLabel
                                    : ''}
                            </div>
                            {!row.isSkip ? (
                                isHide ? (
                                    <FontAwesomeIcon
                                        style={{ marginLeft: '10px', cursor: 'pointer' }}
                                        icon={faChevronDown}
                                    />
                                ) : (
                                    <FontAwesomeIcon
                                        style={{ marginLeft: '10px', cursor: 'pointer' }}
                                        icon={faChevronUp}
                                    />
                                )
                            ) : (
                                ''
                            )}
                        </div>

                        {!isHide ? (
                            <div
                                className={classNames(
                                    styles.targetDescription,
                                    +row.isSkip == 1 ? styles.targetCoverBlock : '',
                                )}
                            >
                                <i>{row?.description}</i>
                            </div>
                        ) : null}
                        {!isHide ? (
                            promptsTitles ? (
                                <div
                                    className={classNames(
                                        styles.targetDescription,
                                        +row.isSkip == 1 ? styles.targetCoverBlock : '',
                                    )}
                                >
                                    <b>Prompt: </b>
                                    <i>{promptsTitles}</i>
                                </div>
                            ) : (
                                ''
                            )
                        ) : null}
                        {!isHide ? (
                            <div
                                className={classNames(styles.timerRow, +row.isSkip == 1 ? styles.targetCoverBlock : '')}
                            >
                                <div
                                    className={
                                        seance?.status == 4 && isJustProvider
                                            ? classNames(styles.frequencyValue, styles.hideEdit, styles.hidePercent)
                                            : showAttempt
                                            ? classNames(styles.hidden)
                                            : classNames(styles.frequencyValue, styles.percentValue)
                                    }
                                >
                                    {percents}
                                </div>
                                <span
                                    className={
                                        seance?.status == 4 && isJustProvider
                                            ? classNames(styles.hideEdit, styles.hidden)
                                            : showAttempt
                                            ? classNames(styles.hidden)
                                            : classNames(styles.editAttemptsButton)
                                    }
                                    onClick={() => {
                                        setShowAttempt(true);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faPencilAlt} />
                                </span>
                            </div>
                        ) : null}

                        {!isHide ? (
                            <div
                                className={classNames(
                                    seance?.status == 4 && isJustProvider ? styles.hideEdit : '',
                                    +row.isSkip == 1 ? styles.targetCoverBlock : '',
                                )}
                            >
                                <div
                                    className={classNames(
                                        styles.wrappedFields,
                                        styles.wrappedFieldsOption,
                                        styles.wrappedFieldsAttemptsOption,
                                        seance?.status == 4 && isJustProvider ? styles.hideEdit : '',
                                        showAttempt ? '' : styles.hidden,
                                    )}
                                >
                                    <div className={classNames(styles.infoSubTitle)}>
                                        Recommended attempts: {recomendedMinAttemps}
                                    </div>

                                    {percentAttempts.map((member: any, index: number, array: any) => (
                                        <div key={`${index}.key`} style={{ position: 'relative', paddingTop: '20px' }}>
                                            <div
                                                key={`${index}.container`}
                                                className={classNames(
                                                    styles.frequencyCounterBox,
                                                    styles.percentageBox,
                                                    seance?.status == 4 && isJustProvider ? styles.hideEdit : '',
                                                )}
                                            >
                                                <span
                                                    key={`${index}.zero`}
                                                    className={classNames(styles.frequencyMinus, styles.fromPrompt)}
                                                    onClick={() => {
                                                        percentAttempts[index] = 0;
                                                        setPercentAttempts(percentAttempts);
                                                        setCurPer(index + 5);
                                                        reCountPercentValue();
                                                        //setIsManualChangeValue(true);
                                                    }}
                                                >
                                                    X
                                                </span>
                                                <div
                                                    key={`${index}.value`}
                                                    className={classNames(styles.frequencyValue)}
                                                >
                                                    {percentAttempts[index]}
                                                </div>
                                                <span
                                                    key={`${index}.max`}
                                                    className={classNames(
                                                        styles.frequencyPlus,
                                                        styles.fromPrompt,
                                                        styles.fromPromptPlus,
                                                    )}
                                                    onClick={() => {
                                                        percentAttempts[index] = 100;
                                                        setPercentAttempts(percentAttempts);
                                                        setCurPer(index + 50);

                                                        reCountPercentValue();
                                                        //setIsManualChangeValue(true);
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faCheck} />
                                                </span>
                                            </div>
                                            <div
                                                className={classNames(styles.removeAttemptButton)}
                                                onClick={() => {
                                                    removeAttempt(index);
                                                    reCountPercentValue();
                                                    //setIsManualChangeValue(true);
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faMinusCircle} />
                                            </div>
                                        </div>
                                    ))}
                                    <div
                                        className={classNames(styles.addAttemptButton)}
                                        onClick={() => {
                                            addAttempt();
                                            reCountPercentValue();
                                            //setIsManualChangeValue(true);
                                        }}
                                    >
                                        +
                                    </div>

                                    <div
                                        className={classNames(styles.saveAttemptsButton)}
                                        onClick={() => {
                                            setPercentOpened(row?.title);
                                            //countPercentValue();
                                            //setIsManualChangeValue(true);
                                            /**HERE**/
                                        }}
                                    >
                                        Done
                                    </div>
                                    <Modal show={percentOpened === row?.title} onHide={handlePercentClose}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Set Percent Value</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>Do you want to set summary percent value of the target?</Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="secondary" onClick={handlePercentClose}>
                                                No
                                            </Button>
                                            <Button
                                                variant="success"
                                                onClick={() => {
                                                    countPercentValue();
                                                    setIsManualChangeValue(true);
                                                    setTargetManualChangeValue(row?.id);
                                                }}
                                            >
                                                Yes
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
                                    <br />
                                    <div
                                        className={classNames(styles.cancelAttemptsButton)}
                                        onClick={() => {
                                            setShowAttempt(false);
                                        }}
                                    >
                                        Cancel
                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </div>
                );
            //duration
            case 2:
                return (
                    <div>
                        <FieldInput
                            name={`${memberD}.answer`}
                            disabled={seance?.status === 4 && isJustProvider}
                            type="hidden"
                            input={{ value: seconds, name: `${memberD}.answer` }}
                            wrapperConfig={{
                                classes: {
                                    inputWrapper: 'm-0',
                                    label: isMasteredLabel
                                        ? classNames(styles.answerTitle, styles.masteryMark)
                                        : classNames(styles.answerTitle),
                                },
                            }}
                        />
                        <div onClick={() => setHide(!isHide)} className={styles.divTarget}>
                            <label
                                className={
                                    isMasteredLabel
                                        ? classNames(styles.answerTitle, styles.masteryMark)
                                        : classNames(styles.answerTitle)
                                }
                            >
                                {row?.title} {isMasteredLabel}
                                <br />
                                <div className={classNames(styles.answerTitle, styles.targetPhase)}>
                                    {row?.isPhased && row?.activePhase
                                        ? '  Phase: ' + row?.activePhase?.title + isMasteredPhaseLabel
                                        : ''}
                                </div>
                                {!row.isSkip ? (
                                    isHide ? (
                                        <FontAwesomeIcon
                                            style={{ marginLeft: '10px', cursor: 'pointer' }}
                                            icon={faChevronDown}
                                        />
                                    ) : (
                                        <FontAwesomeIcon
                                            style={{ marginLeft: '10px', cursor: 'pointer' }}
                                            icon={faChevronUp}
                                        />
                                    )
                                ) : (
                                    ''
                                )}
                            </label>
                        </div>

                        {!isHide ? (
                            <div
                                className={classNames(
                                    styles.targetDescription,
                                    +row.isSkip == 1 ? styles.targetCoverBlock : '',
                                )}
                            >
                                <i>{row?.description}</i>
                            </div>
                        ) : null}
                        {!isHide ? (
                            promptsTitles ? (
                                <div
                                    className={classNames(
                                        styles.targetDescription,
                                        +row.isSkip == 1 ? styles.targetCoverBlock : '',
                                    )}
                                >
                                    <b>Prompt: </b>
                                    <i>{promptsTitles}</i>
                                </div>
                            ) : (
                                ''
                            )
                        ) : null}
                        {!isHide ? (
                            <div
                                className={classNames(
                                    styles.timerBox,
                                    seance?.status == 4 && isJustProvider ? styles.hideEdit : '',
                                    +row.isSkip == 1 ? styles.targetCoverBlock : '',
                                )}
                            >
                                <div className={styles.timerRow}>
                                    <span className={styles.timerPause} onClick={() => {
                                        stop();
                                        setIsManualChangeValue(true);
                                        setTargetManualChangeValue(row?.id);
                                    }}>
                                        <FontAwesomeIcon icon={faStop} />
                                    </span>
                                    <span className={styles.timerValue} id="counter">
                                        {zeroPad(Math.floor(seconds / 60), 2)} : {zeroPad(seconds % 60, 2)}
                                    </span>
                                    {running ? (
                                        <span
                                            className={styles.timerPlay}
                                            onClick={() => {
                                                pause();
                                                setIsManualChangeValue(true);
                                                setTargetManualChangeValue(row?.id);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faPause} />
                                        </span>
                                    ) : (
                                        <span className={styles.timerPlay} onClick={start}>
                                            <FontAwesomeIcon icon={faPlay} />
                                        </span>
                                    )}
                                </div>
                            </div>
                        ) : null}
                        {!isHide ? (
                            <div
                                className={classNames(
                                    seance?.status == 4 && isJustProvider ? styles.hideEdit : '',
                                    +row.isSkip == 1 ? styles.targetCoverBlock : '',
                                )}
                            >
                                <span
                                    className={classNames(styles.timerPause, styles.timerPencil)}
                                    onClick={() => setOpened(row?.title)}
                                >
                                    <FontAwesomeIcon icon={faPencilAlt} />
                                </span>
                            </div>
                        ) : null}
                        {!isHide ? (
                            <Modal show={openModal === row?.title} onHide={handleClose}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Set value manually</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div>For example, the format for 30 sec is 00:30</div>
                                    <input
                                        type="text"
                                        className={styles.timerValue}
                                        id="counterManual"
                                        onChange={(e) => {
                                            //const vars = e.target.value.split(':');
                                            //setSecondsManually(parseInt(vars[0]) * 60 + parseInt(vars[1]));
                                            setSecondsManually(e.target.value);
                                        }}
                                        value={secondsManually}
                                    />
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleClose}>
                                        Close
                                    </Button>
                                    <Button
                                        variant="success"
                                        onClick={() => {
                                            manualChange();
                                            setIsManualChangeValue(true);
                                            setTargetManualChangeValue(row?.id);
                                        }}
                                    >
                                        Ok
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        ) : null}
                    </div>
                );
            //task analysis
            case 3:
                return (
                    <div onClick={() => setHide(!isHide)}>
                        <FieldInput
                            name={`${memberD}.answer`}
                            disabled={seance?.status === 4 && isJustProvider}
                            type="hidden"
                            wrapperConfig={{
                                label: row?.title + isMasteredLabel,
                                classes: {
                                    inputWrapper: 'm-0',
                                    label: isMasteredLabel
                                        ? classNames(styles.answerTitle, styles.answerTitleFix, styles.masteryMark)
                                        : classNames(styles.answerTitle, styles.answerTitleFix),
                                },
                            }}
                        />
                        <div className={classNames(styles.answerTitle, styles.targetPhase)}>
                            {row?.isPhased && row?.activePhase
                                ? '  Phase: ' + row?.activePhase?.title + isMasteredPhaseLabel
                                : ''}
                        </div>

                        {!row.isSkip ? (
                            isHide ? (
                                <FontAwesomeIcon
                                    style={{ marginLeft: '10px', cursor: 'pointer' }}
                                    icon={faChevronDown}
                                />
                            ) : (
                                <FontAwesomeIcon style={{ marginLeft: '10px', cursor: 'pointer' }} icon={faChevronUp} />
                            )
                        ) : (
                            ''
                        )}
                    </div>
                );
            //frequency
            case 4:
                return (
                    <span className={styles.frequencyBox}>
                        <FieldInput
                            name={`${memberD}.answer`}
                            disabled={seance?.status === 4 && isJustProvider}
                            type="hidden"
                            input={{ value: count }}
                            wrapperConfig={{
                                classes: {
                                    inputWrapper: 'm-0',
                                    label: isMasteredLabel
                                        ? classNames(styles.answerTitle, styles.masteryMark)
                                        : classNames(styles.answerTitle),
                                },
                            }}
                        />
                        <div onClick={() => setHide(!isHide)}>
                            <label
                                className={
                                    isMasteredLabel
                                        ? classNames(styles.answerTitle, styles.masteryMark)
                                        : classNames(styles.answerTitle)
                                }
                            >
                                {row?.title} {isMasteredLabel}
                                <br />
                                <div className={classNames(styles.answerTitle, styles.targetPhase)}>
                                    {row?.isPhased && row?.activePhase
                                        ? '  Phase: ' + row?.activePhase?.title + isMasteredPhaseLabel
                                        : ''}
                                </div>
                                {!row.isSkip ? (
                                    isHide ? (
                                        <FontAwesomeIcon
                                            style={{ marginLeft: '10px', cursor: 'pointer' }}
                                            icon={faChevronDown}
                                        />
                                    ) : (
                                        <FontAwesomeIcon
                                            style={{ marginLeft: '10px', cursor: 'pointer' }}
                                            icon={faChevronUp}
                                        />
                                    )
                                ) : (
                                    ''
                                )}
                            </label>
                        </div>
                        {!isHide ? (
                            <div
                                className={classNames(
                                    styles.targetDescription,
                                    +row.isSkip == 1 ? styles.targetCoverBlock : '',
                                )}
                            >
                                <i>{row?.description}</i>
                            </div>
                        ) : null}

                        {!isHide ? (
                            promptsTitles ? (
                                <div
                                    className={classNames(
                                        styles.targetDescription,
                                        +row.isSkip == 1 ? styles.targetCoverBlock : '',
                                    )}
                                >
                                    <b>Prompt: </b>
                                    <i>{promptsTitles}</i>
                                </div>
                            ) : (
                                ''
                            )
                        ) : null}

                        {!isHide ? (
                            <div
                                className={classNames(
                                    styles.frequencyCounterBox,
                                    seance?.status == 4 && isJustProvider ? styles.hideEdit : '',
                                    +row.isSkip == 1 ? styles.targetCoverBlock : '',
                                )}
                            >
                                <span className={classNames(styles.frequencyMinus)} onClick={decrementCount}>
                                    -
                                </span>
                                <div className={classNames(styles.frequencyValue)}>{count}</div>
                                <span className={classNames(styles.frequencyPlus)} onClick={incrementCount}>
                                    +
                                </span>
                            </div>
                        ) : null}
                        {!isHide ? (
                            <div
                                className={classNames(
                                    styles.fixCoverBlock,
                                    seance?.status == 4 && isJustProvider ? styles.hideEdit : '',
                                    +row.isSkip == 1 ? styles.targetCoverBlock : '',
                                )}
                            >
                                <span
                                    className={classNames(styles.timerPause, styles.timerPencil)}
                                    onClick={() => setOpened(row?.title)}
                                >
                                    <FontAwesomeIcon icon={faPencilAlt} />
                                </span>
                            </div>
                        ) : null}
                        {!isHide ? (
                            <Modal show={openModal === row?.title} onHide={handleClose}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Set value manually</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div>Please, use only digits</div>
                                    <input
                                        type="text"
                                        className={styles.timerValue}
                                        id="frequencyManual"
                                        onChange={(e) => {
                                            //const vars = e.target.value.split(':');
                                            //setSecondsManually(parseInt(vars[0]) * 60 + parseInt(vars[1]));
                                            setFrequencyValue(e.target.value);
                                        }}
                                        value={frequencyValue}
                                    />
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleClose}>
                                        Close
                                    </Button>
                                    <Button
                                        variant="success"
                                        onClick={() => {
                                            manualChangeFrequency();
                                            setIsManualChangeValue(true);
                                            setTargetManualChangeValue(row?.id);
                                        }}
                                    >
                                        Ok
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        ) : null}
                    </span>
                );
        }
    };

    return (
        <div>
            <div className={classNames(styles.wrappedFields)}>
                <div>
                    <Link
                        target="_blank"
                        className={classNames(styles.link)}
                        to={Router.generate(routes.PROGRAM_BOOK_TARGET, {
                            id: programBookId,
                            targetId: row.id,
                        })}
                    >
                        <FontAwesomeIcon icon={faChartBar} />
                        See results
                    </Link>
                </div>
                <FieldInput
                    name={`${memberD}.id`}
                    type="hidden"
                    wrapperConfig={{
                        classes: {
                            inputWrapper: 'm-0',
                        },
                    }}
                />
                {+row.isSkip == 1 ? (
                    <button
                        type="button"
                        className={classNames(styles.skipButton)}
                        title="Restore Answer"
                        onClick={() => showRow()}
                    >
                        answer
                    </button>
                ) : (
                    <button
                        type="button"
                        className={classNames(styles.skipButton)}
                        title="Skip Answer"
                        onClick={() => hideRow()}
                    >
                        <FontAwesomeIcon style={{ marginLeft: '10px', cursor: 'pointer' }} icon={faBan} />
                    </button>
                )}
                {input()}
            </div>
            {!isHide ? (
                showOption ? (
                    <div
                        className={classNames(
                            styles.targetDescription,
                            +row.isSkip == 1 ? styles.targetCoverBlock : '',
                        )}
                    >
                        <i>{row?.description}</i>
                    </div>
                ) : (
                    ''
                )
            ) : null}
            {!isHide && !row.isSkip ? (
                showOption ? (
                    row?.isPhased && row?.activePhase && row?.activePhase.programTargetPhaseOptions ? (
                        <FieldArray
                            setIsManualChangeValue={setIsManualChangeValue}
                            isManualChangeValue={isManualChangeValue}
                            setTargetManualChangeValue={setTargetManualChangeValue}
                            targetManualChangeValue={targetManualChangeValue}
                            targetRow={row}
                            name={`${memberD}.activePhase.programTargetPhaseOptions`}
                            component={RenderPhaseStepsArray}
                        />
                    ) : (
                        <FieldArray
                            setIsManualChangeValue={setIsManualChangeValue}
                            isManualChangeValue={isManualChangeValue}
                            setTargetManualChangeValue={setTargetManualChangeValue}
                            targetManualChangeValue={targetManualChangeValue}
                            targetRow={row}
                            name={`${memberD}.programTargetOptions`}
                            component={RenderStepsArray}
                        />
                    )
                ) : null
            ) : null}
            {showPrompt && row.type !== 3 && row.type !== 1 ? (
                <div
                    className={classNames(
                        styles.targetSelectList,
                        seance?.status == 4 && isJustProvider ? styles.hideEdit : '',
                        +row.isSkip == 1 ? styles.targetCoverBlock : '',
                    )}
                >
                    <FieldSelectList
                        name={`${memberD}.promptItem`}
                        data={row?.programTargetPrompts}
                        textField={'title'}
                        valueField={'prompt'}
                        onChange={(e) => {
                            setTimeout(() => {
                                dispatch(change('program-book', `${memberD}.promptItem`, e));
                            }, 200);
                        }}
                    />
                </div>
            ) : null}
        </div>
    );
};
export default PBTargetForm;
